export default "__VITE_ASSET__b9c428f5__"